<template>
    <form @submit.prevent="validateBeforeSubmit" novalidate class="ec-bike-contact-form">
        <div class="modal-body">

            <div v-if="!submitted && !submitting" class="form-horizontal">
                <div class="form-group ec-bike-contact-form-bike-name">
                    <label class="col-sm-3 control-label">Vélo</label>
                    <div class="col-sm-9">
                        <p class="form-control-static">{{ bikeName }}</p>
                    </div>
                </div>

                <div class="form-group" :class="{'has-error': errors.has('title') }">
                    <label class="col-sm-3 control-label">Civilité</label>
                    <div class="col-sm-9">
                        <select2 name="title" v-model="title" class="form-control" placeholder="Votre civilité"
                                 :dropdown-parent="dropdownParent" :allow-clear="true">
                            <option value="M.">M.</option>
                            <option value="Mme.">Mme.</option>
                            <option value="Mlle.">Mlle.</option>
                        </select2>
                    </div>
                </div>

                <div class="form-group" :class="{'has-error': errors.has('name') }">
                    <label class="col-sm-3 control-label">Prénom</label>
                    <div class="col-sm-9">
                        <input name="name" v-model="name" v-validate="'min:2'" class="form-control"
                               placeholder="Votre prénom" data-vv-as="Prénom" autofocus>
                        <p class="text-danger" v-if="errors.has('name')">{{ errors.first('name') }}</p>
                    </div>
                </div>

                <div class="form-group" :class="{'has-error': errors.has('surname') }">
                    <label class="col-sm-3 control-label">Nom</label>
                    <div class="col-sm-9">
                        <input name="surname" v-model="surname" v-validate="'min:2'" class="form-control"
                               placeholder="Votre nom" data-vv-as="Nom">
                        <p class="text-danger" v-if="errors.has('surname')">{{ errors.first('surname') }}</p>
                    </div>
                </div>

                <div class="form-group" :class="{'has-error': errors.has('phone') }">
                    <label class="col-sm-3 control-label">Téléphone</label>
                    <div class="col-sm-9">
                        <input name="phone" v-model="phone" v-validate="'numeric'" class="form-control"
                               type="phone"
                               placeholder="Votre téléphone de contact" data-vv-as="Téléphone">
                        <p class="text-danger" v-if="errors.has('phone')">{{ errors.first('phone') }}</p>
                    </div>
                </div>

                <div class="form-group" :class="{'has-error': errors.has('email') }">
                    <label class="col-sm-3 control-label">Email *</label>
                    <div class="col-sm-9">
                        <input name="email" v-model="email" v-validate="'required|email'" class="form-control"
                               type="email"
                               placeholder="Votre email" data-vv-as="Email">
                        <p class="text-danger" v-if="errors.has('email')">{{ errors.first('email') }}</p>
                    </div>
                </div>

                <div class="form-group" :class="{'has-error': errors.has('message') }">
                    <label class="col-sm-3 control-label">Message *</label>
                    <div class="col-sm-9">
                            <textarea name="message" v-model="message" v-validate="'required|min:10'"
                                      class="form-control" placeholder="Vos questions..." data-vv-as="Message"
                                      rows="4">
                            </textarea>
                        <p class="text-danger" v-if="errors.has('message')">{{ errors.first('message') }}</p>
                    </div>
                </div>

                <div class="form-group">
                    <div class="col-sm-9 col-sm-offset-3">
                        <vue-recaptcha
                                ref="recaptcha"
                                :sitekey="recaptchaKey"
                                @verify="onRecaptchaVerify"
                                @expired="onRecaptchaExpired">
                        </vue-recaptcha>
                    </div>
                </div>
            </div>

            <div v-if="submitting" class="ec-bike-contact-form-submitting">
                <i class="fa fa-spinner fa-spin fa-3x"></i>
            </div>

            <div v-if="submitted" class="alert alert-success">
                <div>
                    <p>
                        Merci pour votre message !
                    </p>
                    <p>
                        On reviendra vers vous dans les plus brefs délais.
                    </p>
                </div>
            </div>

        </div>

        <div class="modal-footer">
            <button class="btn btn-primary" v-if="!submitted" v-bind:disabled="submitting">Envoyer</button>
            <button type="button" class="btn btn-default" data-dismiss="modal">Fermer</button>
        </div>
    </form>


</template>

<style lang="scss" type="text/scss">
    @import "../../../sass/variables";
    @import "../../../sass/mixins";

    $ec-contact-form-height: 60vh;

    .ec-bike-contact-form {
        .modal-body {
            padding-right: $grid-gutter-width*2;

            @media (max-width: $screen-xs-max) {
                padding-right: $grid-gutter-width/2;
            }

            .form-horizontal {
                min-height: $ec-contact-form-height;
            }
        }

        .ec-bike-contact-form-bike-name {
            margin-bottom: $grid-gutter-width/2;
        }

        label {
            // Fixes alignment on small screens
            text-align: right;
            padding-top: $grid-gutter-width/4;
            margin-bottom: 0;
        }

        .text-danger {
            margin-top: $grid-gutter-width/3;
            margin-bottom: 0;
        }

        .ec-bike-contact-form-submitting,
        .alert {
            min-height: $ec-contact-form-height;
            font-size: $ec-font-size-large;
            @include ec-flex-center();
        }

        .alert {
            margin-right: -$grid-gutter-width * 1.5;
            margin-bottom: 0;
            color: $ec-primary-color-dark;
        }

        .form-group {
            margin-bottom: $grid-gutter-width/2;
        }
    }
</style>

<script type="text/babel">
    import VueRecaptcha from 'vue-recaptcha';
    const GA = require('../../modules/ga');

    export default {
        props: ['bikeName', 'bikeId', 'endpoint', 'recaptchaKey'],

        components: {VueRecaptcha},

        data: function () {
            let vm = this;

            return {
                title: '',
                email: '',
                name: '',
                surname: '',
                phone: '',
                message: '',
                captchaResponse: '',
                submitted: false,
                submitting: false,
                dropdownParent: function() {
                    return $(vm.$el);
                }
            }
        },

        methods: {
            onRecaptchaVerify: function (response) {
                this.captchaResponse = response;
            },

            onRecaptchaExpired: function () {
                this.captchaResponse = '';
            },

            validateBeforeSubmit: function () {
                this.$validator.validateAll();

                if (!this.errors.any() && this.captchaResponse) {
                    this.submitForm();
                }
            },

            submitForm: function () {
                this.submitting = true;

                let payload = this.preparePayload();

                let vm = this;

                $.ajax({
                    url: this.endpoint,
                    method: 'post',
                    data: payload,
                    success: function (data) {
                        if (!data || !data.success) {
                            console.error('Wrong payload produced server error:', payload, data);
                            return showServerError();
                        }

                        vm.submitted = true;
                    },
                    error: function () {
                        showServerError();
                    },
                    complete: function () {
                        vm.submitting = false;
                    }
                });

                GA.event('contact-form', 'send', 'Send bike contact form', this.bikeId);
            },

            preparePayload: function () {
                let payload = {
                    email: this.email,
                    message: this.message,
                    captcha: this.captchaResponse
                };

                // Do not send optional fields unless they have a value, or else they will fail server validation
                if (this.title) {
                    payload.title = this.title;
                }

                if (this.name) {
                    payload.name = this.name;
                }

                if (this.surname) {
                    payload.surname = this.surname;
                }

                if (this.phone) {
                    payload.phone = this.phone;
                }

                return payload;
            }
        }
    }
</script>